<template>
  <v-container fluid class="align-start">
    <v-row>
      <v-col cols="8">
        <v-card>
          <v-card-title>
            Suggestions
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-select
                    :items="suggestionTypes"
                    v-model="suggestionType"
                    outlined
                    hide-details
                    label="Suggestion Type"
                    item-type="text"
                    item-value="value"
                >
                  <template v-slot:selection="{ item }">
                    <span>
                      {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <span>
                      {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                    </span>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="6">
                <v-select
                  :items="gameTypes"
                  v-model="gameType"
                  outlined
                  hide-details
                  label="Game Type"
                  item-type="text"
                  item-value="value"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersSuggestions"
                  :items="filteredSuggestions"
                  :loading="loadingSuggestions"
                >

                  <template v-slot:top>
                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex">
                          <span>
                            {#} on suggestion converts to # hands before leaving
                            <br/>
                            e.g. Standing in {#} hands
                          </span>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" dark class="mb-2" @click="openCreateSuggestion">
                            Add Suggestion
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </template>

                  <template v-slot:item.game_type="{ item }">
                    <v-chip label v-for="type of item.game_type" :key="type" class="mr-2">{{ type }}</v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                        color="blue darken-1"
                        small
                        @click="openEditSuggestion(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                        color="red darken-1"
                        small
                        @click="openDeleteSuggestion(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card>
          <v-card-title>
            Suggestions - Types
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                    :headers="headersTypes"
                    :items="types"
                    :loading="loadingTypes"
                >
                  <template v-slot:top>
                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex">
                          <span>Suggestion types</span>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" dark class="mb-2" @click="openCreateType">
                            Add Type
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                        color="blue darken-1"
                        small
                        @click="openEditType(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                        color="red darken-1"
                        small
                        @click="openDeleteType(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Suggestions - Chat Triggers
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-select
                    :items="suggestionTypes"
                    v-model="suggestionTypeTrigger"
                    outlined
                    hide-details
                    label="Suggestion Type"
                    item-type="text"
                    item-value="value"
                >
                  <template v-slot:selection="{ item }">
                    <span>
                      {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <span>
                      {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                    </span>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="6">
                <v-select
                    :items="gameTypes"
                    v-model="gameTypeTrigger"
                    outlined
                    hide-details
                    label="Game Type"
                    item-type="text"
                    item-value="value"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                    :headers="headersTriggers"
                    :items="filteredSuggestionsTriggers"
                    :loading="loadingTriggers"
                >
                  <template v-slot:top>
                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex">
                          <span>Opponent messages that will trigger suggestion</span>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" dark class="mb-2" @click="openCreateTrigger">
                            Add Trigger
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </template>

                  <template v-slot:item.game_type="{ item }">
                    <v-chip label v-for="type of item.game_type" :key="type" class="mr-2">{{ type }}</v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                        color="blue darken-1"
                        small
                        @click="openEditTrigger(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                        color="red darken-1"
                        small
                        @click="openDeleteTrigger(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Users
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headersUsers"
              :items="users"
              :loading="loadingUsers"
            >

              <template v-slot:item.user="{ item }">
                <span :style="item.blocked ? 'color: red' : ''">{{ item.user }}</span>
              </template>

              <template v-slot:item.groups="{ item }">
                <v-chip label v-for="group of item.groups" :key="group" class="mr-2">{{ group }}</v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                    color="red darken-1"
                    small
                    @click="openBlockAccount(item)"
                    v-if="!item.blocked"
                >
                  mdi-cancel
                </v-icon>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="askCreateTrigger" width="500">
      <v-card>
        <v-card-title>
          Add Suggestion Trigger
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  :items="suggestionTypes"
                  v-model="selectTypeTrigger"
                  outlined
                  hide-details
                  label="Type"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="selectGameTypes"
                  v-model="selectGameTypeTrigger"
                  outlined
                  hide-details
                  multiple
                  label="Game Type"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="selectSuggestionTrigger"
                  label="Trigger (case insensitive)"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="createTrigger(); askCreateTrigger=false" :disabled="!isValidCreateTrigger()">Confirm</v-btn>
          <v-btn text @click="askCreateTrigger=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askEditTrigger" width="500">
      <v-card>
        <v-card-title>
          Edit Trigger
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  :items="suggestionTypes"
                  v-model="editingTrigger.type"
                  outlined
                  hide-details
                  label="Type"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="selectGameTypes"
                  v-model="editingTrigger.game_type"
                  outlined
                  hide-details
                  multiple
                  label="Game Type"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="editingTrigger.trigger"
                  label="Trigger (case insensitive)"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="editTrigger(); askEditTrigger=false" :disabled="!isValidEditTrigger()">Confirm</v-btn>
          <v-btn text @click="askEditTrigger=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askDeleteTrigger" width="500">
      <v-card>
        <v-card-title>
          Delete Trigger
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <span>Type: {{ deletingTrigger.type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Game Type: {{ deletingTrigger.game_type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Trigger: {{ deletingTrigger.trigger }}</span>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="deleteTrigger(); askDeleteTrigger=false">Confirm</v-btn>
          <v-btn text @click="askDeleteTrigger=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askCreateType" width="500">
      <v-card>
        <v-card-title>
          Add Type
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="selectTypeType"
                  label="Type"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="selectTypeDescription"
                  label="Description"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="createType(); askCreateType=false" :disabled="!isValidCreateType()">Confirm</v-btn>
          <v-btn text @click="askCreateType=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askEditType" width="500">
      <v-card>
        <v-card-title>
          Edit Type
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="editingType.type"
                  label="Type"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="editingType.description"
                  label="Description"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="editType(); askEditType=false" :disabled="!isValidEditType()">Confirm</v-btn>
          <v-btn text @click="askEditType=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askDeleteType" width="500">
      <v-card>
        <v-card-title>
          Delete Type
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <span>Type: {{ deletingType.type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Description: {{ deletingType.description }}</span>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="deleteType(); askDeleteType=false">Confirm</v-btn>
          <v-btn text @click="askDeleteType=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askBlockAccount" width="500">
      <v-card>
        <v-card-title>
          Block User
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Block user {{ blockAccount.user }}?
            </v-col>
            <v-col cols="12">
              <span style="color: red;">Cannot be undone!</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="blockUser(); askBlockAccount=false">Confirm</v-btn>
          <v-btn text @click="askBlockAccount=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askCreateSuggestion" width="500">
      <v-card>
        <v-card-title>
          Add Suggestion
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  :items="suggestionTypes"
                  v-model="selectType"
                  outlined
                  hide-details
                  label="Type"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="selectGameTypes"
                  v-model="selectGameType"
                  outlined
                  hide-details
                  multiple
                  label="Game Type"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="selectSuggestion"
                label="Suggestion"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="createSuggestion(); askCreateSuggestion=false" :disabled="!isValidCreate()">Confirm</v-btn>
          <v-btn text @click="askCreateSuggestion=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askEditSuggestion" width="500">
      <v-card>
        <v-card-title>
          Edit Suggestion
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  :items="suggestionTypes"
                  v-model="editingSuggestion.type"
                  outlined
                  hide-details
                  label="Type"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="selectGameTypes"
                  v-model="editingSuggestion.game_type"
                  outlined
                  hide-details
                  multiple
                  label="Game Type"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="editingSuggestion.suggestion"
                  label="Suggestion"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="editSuggestion(); askEditSuggestion=false" :disabled="!isValidEdit()">Confirm</v-btn>
          <v-btn text @click="askEditSuggestion=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askDeleteSuggestion" width="500">
      <v-card>
        <v-card-title>
          Delete Suggestion
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <span>Type: {{ deletingSuggestion.type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Game Type: {{ deletingSuggestion.game_type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Suggestion: {{ deletingSuggestion.suggestion }}</span>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="deleteSuggestion(); askDeleteSuggestion=false">Confirm</v-btn>
          <v-btn text @click="askDeleteSuggestion=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "AdminPage",

  computed: {
    filteredSuggestions() {
      return this.suggestions.filter(el => {

        let typeMatch = el.type === this.suggestionType;
        let gameTypeMatch = el.game_type.includes(this.gameType);

        if (this.gameType === "all") {
          gameTypeMatch = true;
        } else if (this.gameType === "poker") {
          if (el.game_type.includes("plo") || el.game_type.includes("plo5c") || el.game_type.includes("nlh") || el.game_type.includes("plo6c")) {
            gameTypeMatch = true;
          }
        }

        return typeMatch && gameTypeMatch;
      })
    },
    filteredSuggestionsTriggers() {
      return this.triggers.filter(el => {

        let typeMatch = el.type === this.suggestionTypeTrigger;
        let gameTypeMatch = el.game_type.includes(this.gameTypeTrigger);

        if (this.gameTypeTrigger === "all") {
          gameTypeMatch = true;
        } else if (this.gameTypeTrigger === "poker") {
          if (el.game_type.includes("plo") || el.game_type.includes("plo5c") || el.game_type.includes("nlh") || el.game_type.includes("plo6c")) {
            gameTypeMatch = true;
          }
        }

        return typeMatch && gameTypeMatch;
      })
    }
  },

  data() {
    return {
      suggestionTypes: [
        { text: 'Thank', description: 'For when someone praise us', value: 'thank' },
        { text: 'Praise', description: 'For when we should praise someone', value: 'praise' },
        { text: 'Warning', description: 'For when we should give warning', value: 'warning' }
      ],
      suggestionType: 'thank',

      suggestionTypeTrigger: 'thank',

      editingTrigger: {},
      deletingTrigger: {},

      editingSuggestion: {},
      deletingSuggestion: {},

      editingType: {},
      deletingType: {},

      headersSuggestions: [
        { text: 'Type', value: 'type' },
        { text: 'Game Type', value: 'game_type' },
        { text: 'Suggestion', value: 'suggestion' },
        { text: 'Actions', value: 'actions' }
      ],
      suggestions: [],
      loadingSuggestions: false,

      headersTriggers: [
        { text: 'Type', value: 'type' },
        { text: 'Game Type', value: 'game_type' },
        { text: 'Trigger', value: 'trigger' },
        { text: 'Actions', value: 'actions' }
      ],
      triggers: [],
      loadingTriggers: false,

      headersUsers: [
        { text: 'Username', value: 'user' },
        { text: 'Password', value: 'password' },
        { text: 'Groups', value: 'groups' },
        { text: 'Actions', value: 'actions' }
      ],
      users: [],
      loadingUsers: false,

      headersTypes: [
        { text: 'Type', value: 'type' },
        { text: 'Description', value: 'description' },
        { text: 'Actions', value: 'actions' }
      ],
      types: [],
      loadingTypes: false,

      gameTypes: [
        { text: 'All', value: 'all' },
        { text: 'Poker', value: 'poker' },
        { text: 'OFC', value: 'ofc' },
        { text: 'NLH', value: 'nlh' },
        { text: 'PLO', value: 'plo' },
        { text: 'PLO5', value: 'plo5c' },
        { text: 'PLO6', value: 'plo6c' }
      ],
      gameType: 'all',

      gameTypeTrigger: 'all',

      selectGameTypes: [
          'ofc',
          'nlh',
          'plo',
          'plo5c',
          'plo6c',
      ],

      selectGameType: 'ofc',
      selectType: 'thank',
      selectSuggestion: '',

      selectGameTypeTrigger: 'ofc',
      selectTypeTrigger: 'thank',
      selectSuggestionTrigger: '',

      selectTypeType: '',
      selectTypeDescription: '',

      askCreateType: false,
      askEditType: false,
      askDeleteType: false,

      askCreateTrigger: false,
      askEditTrigger: false,
      askDeleteTrigger: false,

      askCreateSuggestion: false,
      askEditSuggestion: false,
      askDeleteSuggestion: false,

      askBlockAccount: false,
      blockAccount: {}
    }
  },

  created() {
    this.loadUsers();
    this.loadSuggestions();
    this.loadSuggestionsTriggers();
    this.loadSuggestionTypes();
  },

  methods: {
    loadSuggestions() {
      this.loadingSuggestions = true;
      this.$axios.get("/api/suggestions").then((res) => {
        const data = res.data;

        this.suggestions = data.suggestions;

        this.loadingSuggestions = false;
      }).catch((err) => {
        console.error(err);
      })
    },

    loadSuggestionsTriggers() {
      this.loadingTriggers = true;
      this.$axios.get("/api/suggestions/triggers").then((res) => {
        const data = res.data;

        this.triggers = data.triggers;

        this.loadingTriggers = false;
      }).catch((err) => {
        console.error(err);
      })
    },

    loadSuggestionTypes() {
      this.loadingTypes = true;
      this.$axios.get("/api/suggestions/types").then((res) => {
        const data = res.data;

        this.types = data.types;

        this.suggestionTypes = [];
        for (let type of this.types) {
          this.suggestionTypes.push({
            text: type.type.charAt(0).toUpperCase() + type.type.slice(1),
            description: type.description,
            value: type.type
          })
        }

        this.loadingTypes = false;
      }).catch((err) => {
        console.error(err);
      })
    },

    loadUsers() {
      this.loadingUsers = true;
      this.$axios.get("/api/users").then((res) => {
        const data = res.data;

        this.users = data.users;

        this.loadingUsers = false;
      }).catch((err) => {
        console.error(err);
      })
    },

    createSuggestion() {
      const payload = {
        type: this.selectType,
        game_type: this.selectGameType,
        suggestion: this.selectSuggestion
      }

      this.$axios.post("/api/suggestions", payload).then(() => {
        this.loadSuggestions();
      }).catch((err) => {
        console.error(err);
      })
    },

    createTrigger() {
      const payload = {
        type: this.selectTypeTrigger,
        game_type: this.selectGameTypeTrigger,
        trigger: this.selectSuggestionTrigger
      }

      this.$axios.post("/api/suggestions/triggers", payload).then(() => {
        this.loadSuggestionsTriggers();
      }).catch((err) => {
        console.error(err);
      })
    },

    createType() {
      const payload = {
        type: this.selectTypeType,
        description: this.selectTypeDescription
      }

      this.$axios.post("/api/suggestions/types", payload).then(() => {
        this.loadSuggestionTypes();
      }).catch((err) => {
        console.error(err);
      })
    },

    openCreateType() {
      this.askCreateType = true;
      this.selectTypeType = "";
      this.selectTypeDescription = "";
    },

    openCreateTrigger() {
      this.askCreateTrigger = true;
      this.selectSuggestionTrigger = "";
      this.selectTypeTrigger = this.suggestionTypeTrigger;

      if (this.gameTypeTrigger === "all") {
        this.selectGameTypeTrigger= ["ofc", "plo", "plo5c", "plo6c", "nlh"];
      } else if (this.gameTypeTrigger === "poker") {
        this.selectGameTypeTrigger = ["plo", "plo5c", "plo6c", "nlh"];
      } else {
        this.selectGameTypeTrigger = [this.gameTypeTrigger];
      }
    },

    editType() {
      const payload = {
        type: this.editingType.type,
        description: this.editingType.description
      }

      let id = this.editingType._id;

      this.$axios.post(`/api/suggestions/types/${id}`, payload).then(() => {
        this.loadSuggestionTypes();
      }).catch((err) => {
        console.error(err);
      })
    },

    deleteType() {
      let id = this.deletingType._id;

      this.$axios.delete(`/api/suggestions/types/${id}`).then(() => {
        this.loadSuggestionTypes();
      }).catch((err) => {
        console.error(err);
      })
    },

    editTrigger() {
      const payload = {
        type: this.editingTrigger.type,
        game_type: this.editingTrigger.game_type,
        trigger: this.editingTrigger.trigger
      }

      let id = this.editingTrigger._id;

      this.$axios.post(`/api/suggestions/triggers/${id}`, payload).then(() => {
        this.loadSuggestionsTriggers();
      }).catch((err) => {
        console.error(err);
      })
    },

    deleteTrigger() {
      let id = this.deletingTrigger._id;

      this.$axios.delete(`/api/suggestions/triggers/${id}`).then(() => {
        this.loadSuggestionsTriggers();
      }).catch((err) => {
        console.error(err);
      })
    },

    openCreateSuggestion() {
      this.askCreateSuggestion = true;
      this.selectSuggestion = "";
      this.selectType = this.suggestionType;

      if (this.gameType === "all") {
        this.selectGameType = ["ofc", "plo", "plo5c", "plo6c", "nlh"];
      } else if (this.gameType === "poker") {
        this.selectGameType = ["plo", "plo5c", "plo6c", "nlh"];
      } else {
        this.selectGameType = [this.gameType];
      }
    },

    editSuggestion() {
      const payload = {
        type: this.editingSuggestion.type,
        game_type: this.editingSuggestion.game_type,
        suggestion: this.editingSuggestion.suggestion
      }

      let id = this.editingSuggestion._id;

      this.$axios.post(`/api/suggestions/${id}`, payload).then(() => {
        this.loadSuggestions();
      }).catch((err) => {
        console.error(err);
      })
    },

    deleteSuggestion() {
      let id = this.deletingSuggestion._id;

      this.$axios.delete(`/api/suggestions/${id}`).then(() => {
        this.loadSuggestions();
      }).catch((err) => {
        console.error(err);
      })
    },

    blockUser() {
      this.$axios.post(`/api/users/${this.blockAccount._id}/block`).then(() => {
        this.loadUsers();
      }).catch((err) => {
        console.error(err);
      })
    },

    openEditSuggestion(item) {
      this.askEditSuggestion = true;
      this.editingSuggestion = {...item};
    },

    openDeleteSuggestion(item) {
      this.askDeleteSuggestion = true;
      this.deletingSuggestion = {...item};
    },

    openEditTrigger(item) {
      this.askEditTrigger = true;
      this.editingTrigger = {...item};
    },

    openDeleteTrigger(item) {
      this.askDeleteTrigger = true;
      this.deletingTrigger = {...item};
    },

    openEditType(item) {
      this.askEditType = true;
      this.editingType = {...item};
    },

    openDeleteType(item) {
      this.askDeleteType = true;
      this.deletingType = {...item};
    },

    openBlockAccount(item) {
      this.askBlockAccount = true;
      this.blockAccount = {...item};
    },

    isValidCreate() {
      if (this.selectSuggestion.length < 1) return false;
      return true;
    },

    isValidCreateTrigger() {
      if (this.selectSuggestionTrigger.length < 1) return false;
      return true;
    },

    isValidCreateType() {
      if (this.selectTypeType.length < 2) return false;
      if (this.selectTypeDescription.length < 2) return false;
      return true;
    },

    isValidEdit() {
      if (!this.editingSuggestion) return false;
      if (!this.editingSuggestion.suggestion) return false;
      if (this.editingSuggestion.suggestion.length < 1) return false;
      return true;
    },

    isValidEditTrigger() {
      if (!this.editingTrigger) return false;
      if (!this.editingTrigger.trigger) return false;
      if (this.editingTrigger.trigger.length < 1) return false;
      return true;
    },

    isValidEditType() {
      if (!this.editingType) return false;
      if (!this.editingType.type) return false;
      if (!this.editingType.description) return false;
      if (this.editingType.type.length < 2) return false;
      if (this.editingType.description.length < 2) return false;
      return true;
    },
  }
}
</script>

<style scoped>

</style>
